import React, { useCallback, useEffect, useState } from "react";
import { Configurations } from "../../../Utils/Configurations";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import "./HighLightsV2.scss";
import axios from "axios";
import { withRouter } from "react-router-dom";
import ModalBuscarConteudoV2 from "../../../Components/Modal-Buscar-Conteudo-V2/Modal-Buscar-Conteudo-V2";
import InsertVideo from "../../../Components/Insert-Video/Insert-Video";
import InsertPodcast from "../../../Components/Insert-Podcast/Insert-Podcast";
import ErrorModal from "../../../Components/ErrorModal/ErrorModal";
import ImagesUpload from "../../../Components/Images-Upload/Images-Upload";

const HighLightsDetails = (props) => {
    const estadoInicial = props.location.state || {};

    const [loading, setLoading] = useState(false);
    const [isLoadingDestaqueAtual, setIsLoadingDestaqueAtual] = useState(false);
    const [destaqueAtual, setDestaqueAtual] = useState(null);
    const [tipoBanner, setTipoBanner] = useState("conteudo");
    const [conteudoSelecionado, setConteudoSelecionado] = useState(null);
    const [imagemCustom, setImagemCustom] = useState(estadoInicial.imagem || "");
    const [link, setLink] = useState(estadoInicial.link || "");
    const [tituloCustom, setTituloCustom] = useState(estadoInicial.titulo || "");
    const [bannerNormalizado, setBannerNormalizado] = useState(null);

    const [openModalImagem, setOpenModalImagem] = useState(false);
    const [mensagemValidacao, setMensagemValidacao] = useState("");

    const [modalSuccessYoutube, setModalSuccessYoutube] = useState(false);

    const [openModalBuscarConteudo, setOpenModalBuscarConteudo] = useState(false);
    const [openModalVideo, setOpenModalVideo] = useState(false);
    const [openModalPodcast, setOpenModalPodcast] = useState(false);
    const [loadingModalPeriodico, setLoadingModalPeriodico] = useState(false);
    const [listaArtigos, setListaArtigos] = useState([]);
    const [termo, setTermo] = useState("");
    const [ordenacao, setOrdenacao] = useState("date");
    const [isLoadingInserirVideo, setIsLoadingInserirVideo] = useState(false);
    const [isLoadingInserirPodcast, setIsLoadingInserirPodcast] = useState(false);
    const [isLoadingIncluirConteudoRelacionado, setIsLoadingIncluirConteudoRelacionado] = useState(false);
    const [isLoadingSelecionarConteudo, setIsLoadingSelecionarConteudo] = useState(false);
    //const [isHub, setIsHub] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const idDestaque = props.match && props.match.params ? props.match.params.idDestaque : "novo";
    const isEdicaoDestaque = idDestaque !== "novo";

    const tituloOriginal = ((destaqueAtual && destaqueAtual.titulo) || estadoInicial.titulo || "").trim();
    const tituloInformado = (tituloCustom || "").trim();
    const tituloAlterado = !!tituloInformado && tituloInformado !== tituloOriginal;

    const closeErrorModal = () => {
        setHasError(false);
        setErrorMessage("");
    };

    const handleError = (err) => {
        console.log("ERROR: ", err);
        setHasError(true);
        setErrorMessage((err.response && !!err.response.data.message) ? err.response.data.message : "Erro inesperado.");
    };

    const buscarDestaqueAtual = useCallback(async () => {
        if (!idDestaque || idDestaque === "novo") {
            return;
        }

        const config = new Configurations();
        setIsLoadingDestaqueAtual(true);

        try {
            const response = await axios.get(config.apiBasePath + `/destaques/${idDestaque}`);
            console.log("🚀 ~ HighLightsDetails ~ response:", response.data)
            const dados = response && response.data ? response.data.data : null;
            setDestaqueAtual(dados || null);

            if (dados) {
                setTituloCustom(dados.titulo || "");
            }
        } catch (error) {
            handleError(error);
        } finally {
            setIsLoadingDestaqueAtual(false);
        }
    }, [idDestaque]);

    useEffect(() => {
        buscarDestaqueAtual();
    }, [buscarDestaqueAtual]);

    const montaBannerNormalizado = (conteudo = conteudoSelecionado, tipoAtual = tipoBanner) => {
        const conteudoNormalizado = {};

        if (conteudo && (conteudo.tipo === "video" || conteudo.tipo === "podcast")) {
            conteudoNormalizado.idProg = conteudo.idProg;
            conteudoNormalizado.idEp = conteudo.idEp;
        }

        if (conteudo && conteudo.tipo === "artigo") {
            conteudoNormalizado.id = conteudo.id;
        }

        return {
            tipo: tipoAtual,
            conteudoTipo: conteudo ? conteudo.tipo : null,
            conteudo: conteudoNormalizado,
            imagem: tipoAtual === "custom" ? (imagemCustom || "") : (conteudo && conteudo.imagem ? conteudo.imagem : ""),
            link: tipoAtual === "custom" ? (link || "") : (conteudo && conteudo.link ? conteudo.link : "")
        };
    };

    const toggleModal = () => {
        setModalSuccessYoutube(!modalSuccessYoutube);
        window.history.go(-1);
    };

    const handleChangeTipoBanner = (event) => {
        setTipoBanner(event.target.value);
        setMensagemValidacao("");
    };



    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "link") {
            setLink(value);
            return;
        }

        if (name === "tituloCustom") {
            setTituloCustom(value);
            setMensagemValidacao("");
            return;
        }

    };

    const toggleModalImagem = () => {
        setOpenModalImagem(!openModalImagem);
    };

    const onChangeInputImagem = (e) => {
        setImagemCustom(e.target.value || "");
        setMensagemValidacao("");
    };

    const toggleModalVideo = () => {
        setOpenModalVideo(!openModalVideo);
    };

    const toggleModalPodcast = () => {
        setOpenModalPodcast(!openModalPodcast);
    };

    const carregaUltimosArtigosPublicados = () => {
        const config = new Configurations();
        setLoadingModalPeriodico(true);

        axios
            .get(config.apiBasePath + `/conteudo/artigos/publicados/ultimos`)
            .then((response) => {
                setListaArtigos(response.data.artigos || []);
            })
            .catch(handleError)
            .finally(() => setLoadingModalPeriodico(false));
    };

    const handleChangeBusca = (e) => {
        e.preventDefault();
        const { name, value } = e.target;

        if (name === "termo") {
            setTermo(value);
        }

        if (name === "ordenacao") {
            setOrdenacao(value);
        }
    };

    const buscarTermos = (e) => {
        e.preventDefault();
        const config = new Configurations();
        setLoadingModalPeriodico(true);

        axios
            .get(config.apiBasePath + `/conteudo/artigos/busca/${termo}?ordem=${ordenacao}`)
            .then((response) => {
                setListaArtigos(response.data.artigos || []);
            })
            .catch(handleError)
            .finally(() => setLoadingModalPeriodico(false));
    };

    const toggleModalBuscarConteudo = (tipoConteudo = "artigo") => {
        if (tipoConteudo === "video") {
            toggleModalVideo();
            return;
        }

        if (tipoConteudo === "podcast") {
            toggleModalPodcast();
            return;
        }

        if (!openModalBuscarConteudo) {
            setTermo("");
            setOrdenacao("date");
            carregaUltimosArtigosPublicados();
        }

        setOpenModalBuscarConteudo(!openModalBuscarConteudo);
    };

    const buscarDetalhesVideo = async ({ idProg, idEp, nomeEp }) => {
        const config = new Configurations();
        const response = await axios.get(config.apiBasePath + `/videos/${idProg}/episodios?pagina=1&limite=100`);
        const episodios = response.data.videosEpisodios || [];
        const episodio = episodios.find((item) => Number(item.idVideoEpisodio) === Number(idEp));

        return {
            tipo: "video",
            idProg: Number(idProg),
            idEp: Number(idEp),
            titulo: episodio && episodio.nome ? episodio.nome : (nomeEp || ""),
            dataPublicacao: episodio && (episodio.dtPublicacao || episodio.dataPublicacao) ? (episodio.dtPublicacao || episodio.dataPublicacao) : "",
            imagem: episodio && episodio.imagem ? episodio.imagem : "",
            link: ""
        };
    };

    const buscarDetalhesPodcast = async ({ idProg, idEpisodio, nomeEpisodio }) => {
        const config = new Configurations();
        const response = await axios.get(config.apiBasePath + `/podcasts/${idProg}/episodios?page=1&pageSize=100`);
        const episodios = response.data.data || [];
        const episodio = episodios.find(
            (item) => Number(item.idEpsodio || item.idEpisodio) === Number(idEpisodio)
        );

        return {
            tipo: "podcast",
            idProg: Number(idProg),
            idEp: Number(idEpisodio),
            titulo: episodio && episodio.nome ? episodio.nome : (nomeEpisodio || ""),
            dataPublicacao: episodio && (episodio.dtPublicacao || episodio.dataPublicacao) ? (episodio.dtPublicacao || episodio.dataPublicacao) : "",
            imagem: episodio && episodio.imagem ? episodio.imagem : "",
            link: ""
        };
    };

    const buscarDetalhesArtigo = async (idConteudo) => {
        const idNormalizado = Number(idConteudo);
        const artigoLista = (listaArtigos || []).find((item) => Number(item.idConteudo) === idNormalizado);

        if (artigoLista && artigoLista.titulo) {
            return {
                tipo: "artigo",
                id: idNormalizado,
                titulo: artigoLista.titulo || "",
                dataPublicacao: artigoLista.dtPublicacao || artigoLista.dataPublicacao || "",
                imagem: artigoLista.imagem || "",
                secao: artigoLista.secao,
                sigla: artigoLista.sigla,
                edicao: artigoLista.edicao,
                link: ""
            };
        }

        const config = new Configurations();
        const response = await axios.get(config.apiBasePath + `/conteudo/artigos/${idNormalizado}`);
        const artigo = response.data.artigo || {};

        return {
            tipo: "artigo",
            id: idNormalizado,
            titulo: artigo.titulo || "",
            dataPublicacao: artigo.dtPublicacao || "",
            imagem: artigo.imagem || "",
            secao: artigo.secao,
            sigla: artigo.sigla,
            edicao: artigo.edicao,
            link: ""
        };
    };

    const handleAddVideo = async ({ idProg, idEp, nomeEp }) => {
        setIsLoadingInserirVideo(true);
        setIsLoadingSelecionarConteudo(true);

        try {
            const conteudo = await buscarDetalhesVideo({ idProg, idEp, nomeEp });
            setConteudoSelecionado(conteudo);
            setTituloCustom(conteudo.titulo || "");
            setBannerNormalizado(montaBannerNormalizado(conteudo, "conteudo"));
            setOpenModalVideo(false);
        } catch (error) {
            handleError(error);
        } finally {
            setIsLoadingInserirVideo(false);
            setIsLoadingSelecionarConteudo(false);
        }
    };

    const handleAddPodcast = async ({ idProg, idEpisodio, nomeEpisodio }) => {
        setIsLoadingInserirPodcast(true);
        setIsLoadingSelecionarConteudo(true);

        try {
            const conteudo = await buscarDetalhesPodcast({ idProg, idEpisodio, nomeEpisodio });
            setConteudoSelecionado(conteudo);
            setTituloCustom(conteudo.titulo || "");
            setBannerNormalizado(montaBannerNormalizado(conteudo, "conteudo"));
            setOpenModalPodcast(false);
        } catch (error) {
            handleError(error);
        } finally {
            setIsLoadingInserirPodcast(false);
            setIsLoadingSelecionarConteudo(false);
        }
    };

    const addConteudoRelacionado = async (idConteudo) => {
        setIsLoadingIncluirConteudoRelacionado(true);
        setIsLoadingSelecionarConteudo(true);

        try {
            const conteudo = await buscarDetalhesArtigo(idConteudo);
            setConteudoSelecionado(conteudo);
            setTituloCustom(conteudo.titulo || "");
            setBannerNormalizado(montaBannerNormalizado(conteudo, "conteudo"));
            setOpenModalBuscarConteudo(false);
        } catch (error) {
            handleError(error);
        } finally {
            setIsLoadingIncluirConteudoRelacionado(false);
            setIsLoadingSelecionarConteudo(false);
        }
    };

    const handleSelectVideo = async ({ idProg, idEp, nomeEp }) => {
        await handleAddVideo({ idProg, idEp, nomeEp });
    };

    const handleSelectPodcast = async ({ idProg, idEpisodio, nomeEpisodio }) => {
        await handleAddPodcast({ idProg, idEpisodio, nomeEpisodio });
    };

    const handleSelectArtigo = async (idConteudo) => {
        await addConteudoRelacionado(idConteudo);
    };

    const salvarDestaqueVideo = async (conteudo) => {
        const config = new Configurations();
        const body = {
            tipo: 4,
            localizacao: "hub",
            idVideoPrograma: conteudo.idProg,
            idVideoEpisodio: conteudo.idEp,
            titulo: tituloInformado || conteudo.titulo || "",
            imagem: conteudo.imagem || ""
        };

        await axios.post(config.apiBasePath + `/v2/destaques/novo-destaque`, body)
            .then((res) => {
                toggleModal(res.data.msg);
            })
            .catch((error) => {
                handleError(error);
            });
    };

    const salvarDestaquePodcast = async (conteudo) => {
        const config = new Configurations();
        const body = {
            tipo: 3,
            localizacao: "hub",
            idPoadcast: conteudo.idProg,
            idEpsodio: conteudo.idEp,
            titulo: tituloInformado || conteudo.titulo || "",
            imagem: conteudo.imagem || ""
        };

        await axios.post(config.apiBasePath + `/v2/destaques/novo-destaque`, body)
            .then((res) => {
                toggleModal(res.data.msg);
            })
            .catch((error) => {
                handleError(error);
            });
    };

    const salvarDestaqueArtigo = async (conteudo) => {
        const config = new Configurations();
        const body = {
            tipo: 2,
            localizacao: "hub",
            idConteudo: Number(conteudo.id),
            edicao: conteudo.edicao ? Number(conteudo.edicao) : "",
            sigla: conteudo.sigla ? String(conteudo.sigla).toUpperCase() : "",
            titulo: tituloInformado || conteudo.titulo || "",
            imagem: conteudo.imagem || ""
        };

        await axios.post(config.apiBasePath + `/v2/destaques/novo-destaque`, body)
            .then((res) => {
                toggleModal(res.data.msg);
            })
            .catch((error) => {
                handleError(error);
            });
    };

    const salvarDestaqueCustom = async (payloadBanner) => {
        const config = new Configurations();
        const body = {
            tipo: 5,
            localizacao: "hub",
            imagem: payloadBanner.imagem || "",
            link: payloadBanner.link || "",
            titulo: tituloInformado || "",
        };

        await axios.post(config.apiBasePath + `/v2/destaques/novo-destaque`, body)
            .then((res) => {
                toggleModal(res.data.msg);
            })
            .catch((error) => {
                handleError(error);
            });
    };

    const atualizarTituloDestaque = async () => {
        const config = new Configurations();
        const body = {
            titulo: tituloInformado
        };

        await axios.put(config.apiBasePath + `/destaques/${idDestaque}`, body)
            .then((res) => {
                toggleModal(res.data.msg);
            })
            .catch((error) => {
                handleError(error);
            });
    };

    const cardsIncluirConteudo = [
        {
            nome: "Periódicos",
            icon: "fa-solid fa-newspaper",
            color: "orange",
            acao: () => toggleModalBuscarConteudo("artigo")
        },
        {
            nome: "Vídeo",
            icon: "fas fa-film",
            color: "purple",
            acao: () => toggleModalBuscarConteudo("video")
        },
        {
            nome: "Podcast",
            icon: "fas fa-podcast",
            color: "primary",
            acao: () => toggleModalBuscarConteudo("podcast")
        }
    ];

    const getTipoBadgeColor = (tipo) => {
        const cores = {
            artigo: "orange", video: "purple", podcast: "primary",
            2: "orange", 3: "primary", 4: "purple", 5: "secondary"
        };
        return cores[tipo] || "secondary";
    };

    const getTipoLabel = (tipo) => {
        const labels = {
            artigo: "Periódico", video: "Vídeo", podcast: "Podcast",
            2: "Periódico", 3: "Podcast", 4: "Vídeo", 5: "Customizado"
        };
        return labels[tipo] || tipo || "-";
    };

    const getTipoIcon = (tipo) => {
        const icons = {
            artigo: "fa-newspaper", video: "fa-film", podcast: "fa-podcast",
            2: "fa-newspaper", 3: "fa-podcast", 4: "fa-film", 5: "fa-image"
        };
        return icons[tipo] || "fa-file";
    };

    const podeSalvar = () => {
        if (tipoBanner === "conteudo") {
            if (conteudoSelecionado) {
                return true;
            }

            return isEdicaoDestaque && !!destaqueAtual && tituloAlterado;
        }

        return !!imagemCustom && imagemCustom.trim() !== "";
    };

    const handleSalvarBanner = () => {
        setMensagemValidacao("");

        if (isEdicaoDestaque && !conteudoSelecionado) {
            if (!tituloInformado) {
                setMensagemValidacao("Informe o novo título do destaque.");
                return;
            }

            if (!tituloAlterado) {
                setMensagemValidacao("O título informado é igual ao atual.");
                return;
            }

            setLoading(true);

            const persistirTitulo = async () => {
                try {
                    await atualizarTituloDestaque();
                } catch (error) {
                    handleError(error);
                } finally {
                    setLoading(false);
                }
            };

            persistirTitulo();
            return;
        }

        const payloadBanner = montaBannerNormalizado();
        setBannerNormalizado(payloadBanner);

        if (tipoBanner === "conteudo") {
            if (!conteudoSelecionado) {
                setMensagemValidacao("Selecione um conteúdo existente antes de salvar.");
                return;
            }

            setLoading(true);

            const persistirConteudo = async () => {
                try {
                    if (conteudoSelecionado.tipo === "video") {
                        await salvarDestaqueVideo(conteudoSelecionado);
                    } else if (conteudoSelecionado.tipo === "podcast") {
                        await salvarDestaquePodcast(conteudoSelecionado);
                    } else if (conteudoSelecionado.tipo === "artigo") {
                        await salvarDestaqueArtigo(conteudoSelecionado);
                    }
                } catch (error) {
                    handleError(error);
                } finally {
                    setLoading(false);
                }
            };

            persistirConteudo();
            return;
        }

        if (!imagemCustom || imagemCustom.trim() === "") {
            setMensagemValidacao("Imagem do banner é obrigatória para banner customizado.");
            return;
        }

        setLoading(true);

        const persistirCustom = async () => {
            try {
                await salvarDestaqueCustom(payloadBanner);
            } catch (error) {
                handleError(error);
            } finally {
                setLoading(false);
            }
        };

        persistirCustom();
    };

    // const selectPlataforma = (isHub) => {
    //     setIsHub(isHub);
    // }

    const conteudoPreview = conteudoSelecionado || (
        isEdicaoDestaque && destaqueAtual
            ? {
                tipo: "destaque-atual",
                titulo: destaqueAtual.titulo || "",
                imagem: destaqueAtual.imagem || "",
                dataPublicacao: destaqueAtual.dtPublicacao || destaqueAtual.dataPublicacao || "",
                _id: destaqueAtual._id || "",
                conteudo: destaqueAtual.conteudo || {}
            }
            : null
    );

    if (isLoadingDestaqueAtual) {
        return (
            <div className="cile-remessas">
                <div className="row no-gutters justify-content-center py-5">
                    <div className="col-12 text-center">
                        <div className="spinner-border text-primary" role="status" />
                        <p className="mt-3 mb-0">Carregando destaque...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="cile-remessas">
            <div className="row">
                <div className="col-12 py-2">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-4 text-center text-lg-left">
                            {props.match.params.idDestaque === "novo" ? (
                                <h2 className="title-1 d-none d-lg-block">Novo destaque</h2>
                            ) : (
                                <h2 className="title-1 d-none d-lg-block">Editar destaque</h2>
                            )}
                        </div>
                        <div className="col-12 col-lg-4 text-center">
                            {/* <div className="row no-gutters gap-2 justify-content-center align-items-center">
                                {isEdicaoDestaque ? (
                                    destaqueAtual && destaqueAtual.localizacao ? (
                                        <div className="d-flex align-items-center">
                                            <p className="mb-0 mr-2">Plataforma:</p>
                                            <span className={`badge ${destaqueAtual.localizacao === 'hub' ? 'badge-purple' : 'badge-primary'} text-white`}>
                                                {destaqueAtual.localizacao === 'hub' ? 'Hub' : 'BS+'}
                                            </span>
                                        </div>
                                    ) : null
                                ) : (
                                    <>
                                        <p className="mb-0 mr-3">Plataforma:</p>
                                        <button onClick={() => selectPlataforma(true)} className={isHub ? "btn btn-primary mr-2" : "btn btn-sm btn-outline-secondary mr-2"}>Hub</button>
                                        <button onClick={() => selectPlataforma(false)} className={isHub ? "btn btn-sm btn-outline-secondary" : "btn btn-primary"}>BS +</button>
                                    </>
                                )}
                            </div> */}
                        </div>
                        <div className="col-12 col-lg-4 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="row no-gutters px-3">
                    <div className={"py-3 " + (tipoBanner === "custom" && imagemCustom ? "col-8" : "col-12")}>
                        {!isEdicaoDestaque ? (
                            <>
                                <label className="pl-2"><strong>1. Tipo de banner:</strong></label>
                                <div className="d-flex align-items-center flex-wrap pl-2 mt-2">
                                    <label className="mr-4 mb-2">
                                        <input
                                            type="radio"
                                            name="tipoBanner"
                                            value="conteudo"
                                            checked={tipoBanner === "conteudo"}
                                            onChange={handleChangeTipoBanner}
                                            className="mr-1 cursor-pointer"
                                        />
                                        Usar conteúdo existente
                                    </label>

                                    <label className="mb-2">
                                        <input
                                            type="radio"
                                            name="tipoBanner"
                                            value="custom"
                                            checked={tipoBanner === "custom"}
                                            onChange={handleChangeTipoBanner}
                                            className="mr-1 cursor-pointer"
                                        />
                                        Banner customizado
                                    </label>
                                </div>
                            </>
                        ) : null}

                        {tipoBanner === "conteudo" ? (
                            <>
                                <p className="pl-2 mt-3">
                                    <strong>{isEdicaoDestaque ? "Trocar conteúdo do destaque:" : "2. Selecionar conteúdo:"}</strong>
                                </p>

                                <div className="row no-gutters mt-2 mb-3">
                                    {cardsIncluirConteudo.map((item, index) => (
                                        <div key={`card-conteudo-${index}`} className="col-12 col-lg-3 px-lg-2 py-2">
                                            <button className={`btn btn-outline-${item.color} btn-block text-center`} onClick={item.acao} type="button">
                                                <i className={`item-menu fas ${item.icon} fa-2x`} />
                                                {` ${item.nome}`}
                                            </button>
                                        </div>
                                    ))}
                                </div>

                                {isLoadingSelecionarConteudo ? (
                                    <div className="text-center py-3">
                                        <div className="spinner-border text-primary" role="status" />
                                    </div>
                                ) : conteudoPreview ? (
                                    <>
                                        <p className="pl-2 mb-2"><strong>Conteúdo selecionado:</strong></p>
                                        <div className="card border">
                                            <div className="row no-gutters align-items-center p-3">
                                                <div className="col-4 col-lg-2 text-center">
                                                    {conteudoPreview.imagem ? (
                                                        <img className="img img-fluid rounded" src={conteudoPreview.imagem} alt="preview-conteudo" />
                                                    ) : (
                                                        <div className="text-muted py-3">
                                                            <i className="fas fa-image fa-2x" />
                                                            <p className="mb-0 mt-1"><small>Sem imagem</small></p>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="col-8 col-lg-10 pl-3 text-left">
                                                    <p className="mb-2"><strong>Título original: </strong>{conteudoPreview.titulo || "Conteúdo selecionado"}</p>
                                                    <label className="mb-1"><strong>Título a ser exibido no destaque:</strong></label>
                                                    <input
                                                        name="tituloCustom"
                                                        type="text"
                                                        className="form-control"
                                                        autoComplete="off"
                                                        value={tituloCustom}
                                                        onChange={handleInputChange}
                                                    />
                                                    {conteudoPreview.tipo && conteudoPreview.tipo !== "destaque-atual" ? (
                                                        <span className={`badge d-inline-block mt-2 badge-${getTipoBadgeColor(conteudoPreview.tipo)}`}>
                                                            <i className={`fas ${getTipoIcon(conteudoPreview.tipo)} mr-1`} />
                                                            {getTipoLabel(conteudoPreview.tipo)}
                                                        </span>
                                                    ) : (
                                                        <span className={`badge d-inline-block mt-2 badge-${getTipoBadgeColor(conteudoPreview.conteudo ? conteudoPreview.conteudo.tipo : '')}`}>
                                                            <i className={`fas ${getTipoIcon(conteudoPreview.conteudo ? conteudoPreview.conteudo.tipo : '')} mr-1`} />
                                                            {getTipoLabel(conteudoPreview.conteudo ? conteudoPreview.conteudo.tipo : '')}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : null}
                            </>
                        ) : (
                            <>
                                <label className="pl-2 mt-3"><strong>2. Imagem:</strong></label>
                                <p className="pl-2 mb-2" style={{ fontSize: "14px" }}>Campo obrigatório. Formatos aceitos: jpg, jpeg, png.</p>
                                <div className="pl-2">
                                    <button onClick={toggleModalImagem} className="btn btn-outline-primary" type="button">
                                        <i className="fas fa-image mr-1" />
                                        {imagemCustom ? "alterar imagem" : "selecionar imagem"}
                                    </button>
                                </div>

                                <label className="pl-2 mt-3"><strong>3. Redirecionar para:</strong></label>
                                <p className="pl-2" style={{ fontSize: "14px" }}>Campo opcional. Coloque a url completa</p>
                                <input
                                    name="link"
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    value={link}
                                    onChange={handleInputChange}
                                    placeholder="Ex: https://www.brasilseikyo.com.br/home/bs-digital/edicao/2700"
                                />

                                <label className="pl-2 mt-3"><strong>4. Título a ser exibido no destaque:</strong></label>
                                <p className="pl-2" style={{ fontSize: "14px" }}>Campo opcional.</p>
                                <input
                                    name="tituloCustom"
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    value={tituloCustom}
                                    onChange={handleInputChange}
                                />

                            </>
                        )}

                        {mensagemValidacao ? (
                            <div className="pl-2 mt-2">
                                <small className="text-danger">{mensagemValidacao}</small>
                            </div>
                        ) : null}
                    </div>

                    {tipoBanner === "custom" && imagemCustom ? (
                        <div className="col-4 py-3 pl-3">
                            <p className="mb-2"><strong>Pré-visualização:</strong></p>
                            <div className="card border p-2">
                                <img className="img img-fluid rounded" src={imagemCustom} alt="preview-banner-custom" />
                            </div>
                        </div>
                    ) : null}

                    <div className="col-12 text-right py-2">
                        {loading ? (
                            <div className="spinner-border text-success" role="status" />
                        ) : (
                            <button className="btn btn-outline-success" disabled={!podeSalvar()} onClick={handleSalvarBanner} type="button">
                                {isEdicaoDestaque ? "Salvar destaque" : "Adicionar destaque"}
                            </button>
                        )}
                    </div>
                </div>
            </div>

            <ModalBuscarConteudoV2
                toggle={() => toggleModalBuscarConteudo("artigo")}
                isOpen={openModalBuscarConteudo}
                posicao={1}
                listaArtigos={listaArtigos}
                atualizarDestaque={() => { }}
                handleChange={handleChangeBusca}
                buscarTermos={buscarTermos}
                termo={termo}
                ordenacao={ordenacao}
                match={{ params: { periodico: "bs", numEdicao: "sem-edicao" } }}
                history={props.history}
                isLoadingArtigos={loadingModalPeriodico || isLoadingIncluirConteudoRelacionado}
                addConteudoRelacionado={handleSelectArtigo}
            />

            <InsertVideo
                isOpen={openModalVideo}
                toggle={toggleModalVideo}
                handleModalVideo={handleSelectVideo}
                isLoadingInserirVideo={isLoadingInserirVideo}
                flagContent={true}
            />

            <InsertPodcast
                isOpen={openModalPodcast}
                toggle={toggleModalPodcast}
                handleModalPodcast={handleSelectPodcast}
                isLoadingInserirPodcast={isLoadingInserirPodcast}
                flagContent={true}
            />

            <Modal className="modal-upload-imagem" size="lg" isOpen={openModalImagem} toggle={toggleModalImagem}>
                <ModalHeader toggle={toggleModalImagem}>
                    Upload de imagem
                </ModalHeader>
                <ModalBody>
                    <ImagesUpload
                        toggle={toggleModalImagem}
                        onChangeInput={onChangeInputImagem}
                        imgNoTexto={false}
                        realizaBusca={!!imagemCustom}
                        urlImagemBusca={imagemCustom}
                    />
                </ModalBody>
            </Modal>

            <Modal isOpen={modalSuccessYoutube} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>CILE - Banner</ModalHeader>
                <ModalBody>
                    {!bannerNormalizado && isEdicaoDestaque
                        ? "Título atualizado com sucesso!"
                        : bannerNormalizado && bannerNormalizado.tipo === "conteudo"
                            ? "Conteúdo incluído com sucesso!"
                            : "Banner atualizado com sucesso!"}
                </ModalBody>
                <ModalFooter>
                    <Button color="success" onClick={toggleModal}>ok</Button>
                </ModalFooter>
            </Modal>

            <ErrorModal
                isOpen={hasError}
                message={errorMessage}
                closeErrorModal={closeErrorModal}
                goBack={!hasError}
            />
        </div>
    );
};

export default withRouter(HighLightsDetails);
